import { render } from "./TournamentGallery.vue?vue&type=template&id=02aec1d0&scoped=true"
import script from "./TournamentGallery.vue?vue&type=script&lang=js"
export * from "./TournamentGallery.vue?vue&type=script&lang=js"

import "./TournamentGallery.vue?vue&type=style&index=0&id=02aec1d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02aec1d0"]])

export default __exports__